import { createFileRoute } from "@tanstack/react-router";
import { CountryPage, ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { GOLD_COUNTRY_ALIASES, goldCountryAliasMeta, buildAliasHead } from "@/lib/alias-routes";

const A = GOLD_COUNTRY_ALIASES.find((x) => x.slug === "gold-rate-india")!;
const M = goldCountryAliasMeta(A);

export const Route = createFileRoute("/gold-rate-india")({
  head: () => buildAliasHead({ title: M.title, description: M.description, path: M.path }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("india"));
  },
  component: () => (
    <CountryPage country="india" title={M.h1} intro="Live 24K, 22K and 21K gold rates across every major Indian city — recalculated every 10 minutes from international spot price + today's USD/INR rate." />
  ),
});